import React from "react";

const NotFound = () => {
  return <h1>Whoops! This page is missing.</h1>;
};

export default NotFound;
